import React from 'react';
import impactDrivenIcon from '../assests/impact_driven.png';
import fastReliableIcon from '../assests/fast_reliable_delivery.png';
import transparentFairIcon from '../assests/transparent_fair.png';
import expertProblemSolversIcon from '../assests/expert_problem_solvers.png';
import seamlessCollabrationIcon from '../assests/seamless_collabration.png';
import directAccessIcon from '../assests/direct_access.png';

const WhyChooseUs = () => {
  const features = [
    {
      title: 'Impact-Driven Solutions',
      description:
        'Every product we build is custom- crafted to create real business impact.',
      icon: impactDrivenIcon,
    },
    {
      title: 'Fast & Reliable Delivery',
      description: 'Get high-quality results in days or weeks, not months.',
      icon: fastReliableIcon,
    },
    {
      title: 'Transparent & Fair Pricing',
      description:
        'Honest, customized pricing with no hidden fees or surprises.',
      icon: transparentFairIcon,
    },
    {
      title: 'Expert Problem Solvers',
      description:
        'We tackle technical and creative challenges with innovative solutions.',
      icon: expertProblemSolversIcon,
    },
    {
      title: 'Seamless Collaboration',
      description:
        'Clear communication and feedback at every stage of the project.',
      icon: seamlessCollabrationIcon,
    },
    {
      title: 'Direct Access to Top Talent',
      description:
        'Work directly with senior experts—no long-term hiring needed.',
      icon: directAccessIcon,
    },
  ];

  return (
    <section className='bg-neutral-100 pt-3'>
      {/* Heading Section */}
      <div className='flex items-center justify-center px-4 sm:px-8 py-3'>
        <div className='max-w-[758px]'>
          <h2 className='text-[36px] font-semibold text-black text-center leading-[43.2px] tracking-[-0.9px]'>
            Why should you <br /> choose us
          </h2>
        </div>
      </div>

      {/* Features Grid */}
      <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12'>
        <div className='max-w-[1066px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8'>
          {features.map((feature, index) => (
            <div
              key={index}
              className='flex flex-col items-center text-center gap-3'
            >
              {/* Icon - 96x96px with 40px top padding */}
              <div className='w-24 h-24 flex items-center justify-center pt-10'>
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className='w-full h-full object-contain'
                />
              </div>

              {/* Title - Inter Medium, 20px */}
              <h3 className='text-[20px] font-medium text-black leading-[20px]'>
                {feature.title}
              </h3>

              {/* Description - Inter Regular, 16px */}
              <p className='text-[16px] font-normal text-black leading-[19.2px] max-w-[300px]'>
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
